import { render, staticRenderFns } from "./icon-colored-check.vue?vue&type=template&id=e73630c8&"
import script from "./icon-colored-check.vue?vue&type=script&lang=js&"
export * from "./icon-colored-check.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports